$(document).ready(function () {
    
        $(window).scroll(function() {
            if ($('.active-on-visible').length > 0) {
                $.each($('.active-on-visible'), function (k,v) {
                    if ($(this).isInViewport()) {
                        $(this).addClass('active');
                    } else {
                        $(this).removeClass('active');
                    }
                })
                
            }

            if ($('.page-home').length || $('.page-servizi').length) {
                if ($('.mainNavbar.onCarusell').isInViewport()) {
                    $('body').removeClass('showing-navbar-black');
                } else {
                    $('body').addClass('showing-navbar-black');
                }
            }
        });
    

});
